import type { IPrepareData } from '@/types'

interface SolanaPrepareDataConstructor {
  blockhash: string
  lastValidBlockHeight: number
  lamportsPerSignature: number
  priorityFee: number
  rentFee?: number
  keepRentFee?: number
}

export class SolanaPrepareData implements IPrepareData {
  public blockhash: string
  public lastValidBlockHeight: number
  public lamportsPerSignature: number
  public priorityFee: number
  public rentFee?: number
  public keepRentFee?: number

  constructor(data: SolanaPrepareDataConstructor) {
    this.blockhash = data.blockhash
    this.lastValidBlockHeight = data.lastValidBlockHeight
    this.lamportsPerSignature = data.lamportsPerSignature
    this.priorityFee = data.priorityFee
    this.rentFee = data.rentFee
    this.keepRentFee = data.keepRentFee
  }
}
